import React from 'react';
import { useIntl } from 'umi';
import { Layout } from 'tea-component';
import OverlapAnalysisContent from './content';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';

const { Content } = Layout;

const OverlapAnalysis: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <Content className="affix-target dbi-overlapanalysis-page ">
      <Content.Header title={formatMessage({ id: 'dbi_overlapanylistis_mobile_title' })} />
      <Content.Body full>
        <MarqueeBanner />
        <OverlapAnalysisContent
          pageLogConfigKey="topchartOverlapAnalysisMobileGames"
          downloadLogConfigKey="topChartOverlapAnalysisMobileGamesDownloadClick"
        />
      </Content.Body>
    </Content>
  );
};

export default OverlapAnalysis;
